module.exports = __webpack_public_path__ + "img/Urologue.daa4aa8a.png";